import { createSlice } from '@reduxjs/toolkit'
import { merge } from 'components/util'
import * as autoThunks from 'features/auto-thunks'
import Series from './series-model'
import {
  CreateSeriesAsync,
  DeleteSeriesAsync,
  LoadSeriessAsync,
} from './series-thunk'
const initialState: seriesSliceState = {
  series: [],
  selected_series: '',
  is_loading_series: false,
  is_creating_series: false,
  is_deleting_series: false,
}
export interface seriesSliceState {
  series: Series[]
  selected_series?: string
  is_loading_series: boolean
  is_creating_series: boolean
  is_deleting_series: boolean
}
export const seriesSlice = createSlice({
  name: 'series',
  initialState,
  reducers: {
    setSelectedseries: (state, action) => {
      state.selected_series = action.payload
    },
    clearStateseries: (state) => {
      state.series = []
      state.is_loading_series = false
      state.is_creating_series = false
      state.is_deleting_series = false
    },
    mergeseries: (state, action) => {
      if (action.payload) {
        let payload: any = action.payload
        if (payload?.data) {
          if (!Array.isArray(payload.data)) {
            state.selected_series = payload?.data?.id
            payload = [payload.data]
          } else {
            payload = payload.data
          }
          state.series = merge(state.series, payload) as any
        }
      }
    },

    add_series: (state, action) => {
      if (action.payload) {
        state.series = [...state.series, action.payload]
      }
    },
    set_series: (state, action) => {
      let { key, value, id } = action.payload
      state.series = state.series.map((item) => {
        if (item && item.id === id) {
          return {
            ...item,
            [key]: value,
          }
        }
        return item
      })
    },
  },
  extraReducers: (builder) => {
    builder.addCase('LOGOUT', () => {
      return { ...initialState }
    })

    builder.addCase(LoadSeriessAsync.pending, (state) => {
      state.is_loading_series = true
    })
    builder.addCase(LoadSeriessAsync.fulfilled, (state, action) => {
      state.is_loading_series = false
      if (action.payload) {
        state.series = action.payload
      }
    })
    builder.addCase(LoadSeriessAsync.rejected, (state) => {
      state.is_loading_series = false
    })
    builder.addCase(CreateSeriesAsync.pending, (state) => {
      state.is_creating_series = true
    })
    builder.addCase(CreateSeriesAsync.fulfilled, (state) => {
      state.is_creating_series = false
    })
    builder.addCase(CreateSeriesAsync.rejected, (state) => {
      state.is_creating_series = false
    })
    builder.addCase(DeleteSeriesAsync.pending, (state) => {
      state.is_deleting_series = true
    })
    builder.addCase(DeleteSeriesAsync.fulfilled, (state, action) => {
      state.is_deleting_series = false
      if (state.series) {
        state.series = state.series.filter((x) => action.payload.id !== x.id)
      }
    })
    builder.addCase(DeleteSeriesAsync.rejected, (state) => {
      state.is_deleting_series = false
    })

    builder.addCase(
      autoThunks.fetch_series_for_approval_evaluation.pending,
      (state) => {
        state.is_loading_series = true
      },
    )
    builder.addCase(
      autoThunks.fetch_series_for_approval_evaluation.fulfilled,
      (state, action) => {
        state.is_loading_series = false
        handleResult(action, state)
      },
    )
    builder.addCase(
      autoThunks.fetch_series_for_approval_evaluation.rejected,
      (state) => {
        state.is_loading_series = false
      },
    )

    builder.addCase(
      autoThunks.get_content_house_series_on_seasons.pending,
      (state) => {
        state.is_loading_series = true
      },
    )
    builder.addCase(
      autoThunks.get_content_house_series_on_seasons.fulfilled,
      (state, action) => {
        state.is_loading_series = false
        handleResult(action, state)
      },
    )
    builder.addCase(
      autoThunks.get_content_house_series_on_seasons.rejected,
      (state) => {
        state.is_loading_series = false
      },
    )

    builder.addCase(autoThunks.update_series_season_order.pending, (state) => {
      state.is_loading_series = true
    })
    builder.addCase(
      autoThunks.update_series_season_order.fulfilled,
      (state, action) => {
        state.is_loading_series = false
        handleResult(action, state)
      },
    )
    builder.addCase(autoThunks.update_series_season_order.rejected, (state) => {
      state.is_loading_series = false
    })

    builder.addCase(autoThunks.get_content_house_series.pending, (state) => {
      state.is_loading_series = true
    })
    builder.addCase(
      autoThunks.get_content_house_series.fulfilled,
      (state, action) => {
        state.is_loading_series = false
        handleResult(action, state)
      },
    )
    builder.addCase(autoThunks.get_content_house_series.rejected, (state) => {
      state.is_loading_series = false
    })

    builder.addCase(autoThunks.storeSeriesForContentHouse.pending, (state) => {
      state.is_loading_series = true
    })
    builder.addCase(
      autoThunks.storeSeriesForContentHouse.fulfilled,
      (state, action) => {
        state.is_loading_series = false
        handleResult(action, state)
      },
    )
    builder.addCase(autoThunks.storeSeriesForContentHouse.rejected, (state) => {
      state.is_loading_series = false
    })

    builder.addCase(
      autoThunks.requestSeriesContentApprovalForContentHouse.pending,
      (state) => {
        state.is_loading_series = true
      },
    )
    builder.addCase(
      autoThunks.requestSeriesContentApprovalForContentHouse.fulfilled,
      (state, action) => {
        state.is_loading_series = false
        handleResult(action, state)
      },
    )
    builder.addCase(
      autoThunks.requestSeriesContentApprovalForContentHouse.rejected,
      (state) => {
        state.is_loading_series = false
      },
    )

    builder.addCase(
      autoThunks.cancelSeriesContentApprovalForContentHouse.pending,
      (state) => {
        state.is_loading_series = true
      },
    )
    builder.addCase(
      autoThunks.cancelSeriesContentApprovalForContentHouse.fulfilled,
      (state, action) => {
        state.is_loading_series = false
        handleResult(action, state)
      },
    )
    builder.addCase(
      autoThunks.cancelSeriesContentApprovalForContentHouse.rejected,
      (state) => {
        state.is_loading_series = false
      },
    )

    builder.addCase(
      autoThunks.get_series_for_release_management_by_content_house.pending,
      (state) => {
        state.is_loading_series = true
      },
    )
    builder.addCase(
      autoThunks.get_series_for_release_management_by_content_house.fulfilled,
      (state, action) => {
        state.is_loading_series = false
        handleResult(action, state)
      },
    )
    builder.addCase(
      autoThunks.get_series_for_release_management_by_content_house.rejected,
      (state) => {
        state.is_loading_series = false
      },
    )

    builder.addCase(autoThunks.load_series.pending, (state) => {
      state.is_loading_series = true
    })
    builder.addCase(autoThunks.load_series.fulfilled, (state, action) => {
      state.is_loading_series = false
      handleResult(action, state)
    })
    builder.addCase(autoThunks.load_series.rejected, (state) => {
      state.is_loading_series = false
    })

    builder.addCase(
      autoThunks.get_series_for_system_schedules.pending,
      (state) => {
        state.is_loading_series = true
      },
    )
    builder.addCase(
      autoThunks.get_series_for_system_schedules.fulfilled,
      (state, action) => {
        state.is_loading_series = false
        handleResult(action, state)
      },
    )
    builder.addCase(
      autoThunks.get_series_for_system_schedules.rejected,
      (state) => {
        state.is_loading_series = false
      },
    )
  },
})

function handleResult(action: any, state: seriesSliceState) {
  if (action.payload) {
    let payload: any = action.payload
    if (payload?.data) {
      if (!Array.isArray(payload.data)) {
        state.selected_series = payload?.data?.id
        payload = [payload.data]
      } else {
        payload = payload.data
      }
      state.series = merge(state.series, payload) as any
    }
  }
}

export const {
  clearStateseries,
  setSelectedseries,
  set_series,
  mergeseries,
  add_series,
} = seriesSlice.actions

export const get_series =
  (id?: string) =>
  (state: {
    series: {
      series: Series[]
    }
  }): Series | null => {
    let temp = state?.series?.series?.find((v) => v.id === id)
    if (temp) {
      return temp
    }
    return state?.series?.series[0] || null
  }
export const get_selected_series = (state: {
  series: seriesSliceState
}): Series | null => {
  let id = state?.series?.selected_series
  let temp = state?.series?.series?.find((v) => v.id === id)
  if (temp) {
    return temp
  }
  return null
}
export const get_all_series = (state: {
  series: {
    series: Series[]
  }
}): Series[] => {
  let temp = state?.series?.series
  if (temp) {
    return temp.filter((x) => !x.deleted)
  }
  return []
}
export const is_series_busy = (state: { series: seriesSliceState }) => {
  return (
    state?.series.is_deleting_series ||
    state?.series.is_loading_series ||
    state?.series.is_creating_series
  )
}
export const is_deleting_series_busy = (state: {
  series: seriesSliceState
}) => {
  return state?.series.is_deleting_series
}
export const is_loading_series_busy = (state: { series: seriesSliceState }) => {
  return state?.series.is_loading_series
}
export const is_creating_series_busy = (state: {
  series: seriesSliceState
}) => {
  return state?.series.is_creating_series
}

export default seriesSlice.reducer
